// extracted by mini-css-extract-plugin
export var dropdownButton = "_z-0";
export var fullWidthDropdownButton = "_z-1";
export var icon = "_z-3";
export var iconPlaceholder = "_z-2";
export var menuItemRow = "_z-9";
export var separator = "_z-e";
export var shortcutContainer = "_z-7";
export var shortcutContainerFilled = "_z-8";
export var shortcutIconLg = "_z-6";
export var shortcutIconMd = "_z-5";
export var shortcutIconSm = "_z-4";
export var submenuChevron = "_z-d";
export var submenuDropdown = "_z-a";
export var submenuTriggerRow = "_z-b";
export var submenuTriggerRowOpen = "_z-c";